<template>
  <div class="hello">
    <div class="container">
      <div class="row">
        <div class="col-md-10 col-md-offset-1">
          <h1 class="page-header">CollectoCat
            <img :src="user.avatarUrl() ? user.avatarUrl() : '/avatar-placeholder.png'" class="avatar">
            <small><span class="sign-out">(<a href="#" @click.prevent="signOut">Sign Out</a>)</span></small>
          </h1>

          <h2 class="user-info">
            <small>
              Start to collect your owls...
            </small>
            <small class="pull-right">
              {{ user.username ? user.username : user.identityAddress }}
            </small>
          </h2>

          <div v-for="owl in owls" v-html="owl">
            {{owl}}
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
  const STORAGE_FILE = 'user_owls.json'

  export default {
    name: 'dashboard',
    props: ['user'],
    data () {
      return {
        blockstack: window.blockstack,
        owls: {}
      }
    },
    mounted () {
      this.fetchData(this.fetchParameters)
    },
    methods: {
      removeOwl: function (owl) {
        delete this.owls[owl]
        this.saveOwls()
      },

      saveOwls () {
        const blockstack = this.blockstack
        const that = this
        blockstack.putFile(STORAGE_FILE, JSON.stringify(this.owls))
          .then(
            function (result) {
              that.fetchData()
            }
          )
      },

      addOwl (owlSvg, owlHash, owlConfig) {
        this.owls[owlHash + '_' + owlConfig] = owlSvg
        this.saveOwls()
      },

      showCam () {
        this.initInstascan()
        document.getElementById('addImage').style.visibility = 'hidden'
        document.getElementById('preview').style.visibility = 'visible'
        document.getElementById('preview').style.height = '300px'
      },

      hiddeCam () {
        let scanner = new Instascan.Scanner({video: document.getElementById('preview')})
        Instascan.Camera.getCameras().then(function (cameras) {
          if (cameras.length > 0) {
            scanner.stop(cameras[0])
          } else {
            console.error('No cameras found.')
          }
        }).catch(function (e) {
          console.error(e)
        })
        document.getElementById('addImage').style.visibility = 'visible'
        document.getElementById('preview').style.visibility = 'hidden'
        document.getElementById('preview').style.height = '0px'
      },

      initInstascan () {
        const blockstack = this.blockstack
        const that = this
        let scanner = new Instascan.Scanner({video: document.getElementById('preview')})
        scanner.addListener('scan', function (content) {
          var data = JSON.parse(content)
          var kittenhash = sha1(data.hash + blockstack.loadUserData().appPrivateKey)

          console.log('Generated kitten hash: ' + kittenhash)

          that.fetchConfig(data.config, function (conf) {

            console.log('using config ' + data.config)
            that.addKitten(generateKitten(kittenhash, conf), kittenhash)
            that.hiddeCam()
          })

        })
        Instascan.Camera.getCameras().then(function (cameras) {
          if (cameras.length > 0) {
            scanner.start(cameras[0])
          } else {
            console.error('No cameras found.')
          }
        }).catch(function (e) {
          console.error(e)
        })
      },

      fetchConfig (conf, cb) {
        $.getJSON('/configs/' + conf + '.json', function (res) {
          cb(res)
        })
      },

      fetchData (cb) {
        let options = {
          encrypt: true
        }
        const blockstack = this.blockstack
        const that = this
        blockstack.getFile(STORAGE_FILE, options) // decryption is enabled by default
          .then((data) => {
            that.owls = JSON.parse(data || '{}')
            // console.log('Fetched data: ' + that.owls)
            if (cb) cb()
          })
      },

      signOut () {
        const blockstack = this.blockstack
        blockstack.signUserOut(window.location.href)
      },

      fetchParameters () {
        let searchParams = new URLSearchParams(window.location.search)
        let type = searchParams.get('type')
        let hash = searchParams.get('hash')
        let config = searchParams.get('config')
        let that = this

        const blockstack = this.blockstack

        if (hash) {
          let owlHash = sha1(hash + blockstack.loadUserData().appPrivateKey)

          this.fetchConfig(config, function (conf) {
            console.log('adding ' + hash + ' using config ' + config)
            that.addOwl(generateOwl(owlHash, conf, config), owlHash, config)
          })
        }
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

  input::placeholder {
    color: grey;
  }

  #addImage {
    height: 295px;
    width: 295px;
    border: 1px solid black;
  }

  #preview {
    height: 300px;
    width: 300px;
  }

  label {
    margin-bottom: 0;
    // width: 100%;
    cursor: pointer;

    input[type="checkbox"] {
      margin-right: 5px;
    }
  }

  .list-group-item {
    .delete {
      display: none;
    }


    &:hover .delete {
      display: inline;
      color: grey;

      &:hover {
        text-decoration: none;
        color: red;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// Dashboard.vue?7ab8e6d7